import React, { memo, useCallback, useMemo } from 'react';
import { View } from 'react-native';
import { Button, CardView, Spacer } from 'design-system';
import { IconRocket } from 'design-system/icons/IconRocket';
import Squircle from 'design-system/Squircle';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { blockInvestActionOnWeb } from '../webGate';
import { selectAutoInvestAllocations, selectAutoInvestPlanForAccount, selectActiveTradingAccountId, selectTradingAccount, } from '../reducers/selectors';
const AutoinvestUpsellCard = ({ assetId }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const { navigate } = useMainStackNavigation();
    const tradingAccount = useAppSelector(selectTradingAccount);
    const accountId = useAppSelector(selectActiveTradingAccountId) ?? '';
    const accountType = tradingAccount?.account.accountType;
    const plan = useAppSelector((state) => selectAutoInvestPlanForAccount(state, accountId));
    const existingAllocations = useAppSelector(selectAutoInvestAllocations);
    const hasFetchedAutoinvestPlans = useAppSelector((state) => !!state.invest.autoInvestPlans);
    const isAssetInAutoinvest = useMemo(() => plan?.allocations.some((a) => a.assetId === assetId), [plan, assetId]);
    const handlePress = useCallback(() => {
        if (!accountType || !hasFetchedAutoinvestPlans)
            return;
        if (blockInvestActionOnWeb('Add to autoinvest'))
            return;
        if (plan) {
            navigate('AutoinvestAllocation', {
                accountType,
                planId: plan.id,
                isEditMode: true,
                isUpsellFlow: true,
                wasPaused: plan.status === 'paused',
                initialAllocations: [
                    {
                        assetId,
                        percentage: 0,
                    },
                    ...(existingAllocations || []),
                ],
            });
        }
        else {
            navigate('AutoinvestIntro', { accountType });
        }
    }, [accountType, hasFetchedAutoinvestPlans, existingAllocations, plan, assetId]);
    if (!hasFetchedAutoinvestPlans || isAssetInAutoinvest)
        return null;
    return (<CardView noMarginBottom style={styles.card}>
      <View style={styles.row}>
        <Squircle color={colors.background.dark}>
          <IconRocket color={colors.text.investment}/>
        </Squircle>
        <View style={styles.textContainer}>
          <Text Text-16>Make it recurring</Text>
          <Text TextThin-14 Secondary>
            {'This fund isn\u2019t included in your monthly autoinvest yet.'}
          </Text>
        </View>
      </View>
      <Spacer h={24}/>
      <Button square brandReversed title="Add to autoinvest" onPress={handlePress}/>
    </CardView>);
};
const styleSet = createStyleSheets((_colors) => ({
    card: {
        paddingHorizontal: rem(16),
        paddingVertical: rem(16),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    textContainer: {
        flex: 1,
        marginLeft: rem(12),
    },
}));
export default memo(AutoinvestUpsellCard);
